<template>
  <el-dialog
    :title="`${curRow.name}${curRow.code}使用情况`"
    :visible.sync="dialogVisibleDt"
    width="1000px"
    @close="reset"
    class="room-use-detail"
  >
    <div v-loading="loading">
      <el-button type="primary" @click="exportExcel">导出</el-button>
      <el-calendar @input="setNewMonth" v-model="caDate">
        <template slot="dateCell" slot-scope="{ date, data }">
          <div class="day"  @click="clickDay(data)">
            <div class="now">{{ date.getDate() }}</div>
            <template>
              <div v-if="roomUseDetail[data.day]">
                <el-button
                  class="morning"
                  @click.native="() => activeItem('morning', data.day)"
                  v-if="roomUseDetail[data.day].morning.length"
                  >上午：{{ roomUseDetail[data.day].morning.length }}班</el-button
                >
                <el-button
                  class="afternoon"
                  @click.native="() => activeItem('afternoon', data.day)"
                  v-if="roomUseDetail[data.day].afternoon.length"
                  >下午：{{ roomUseDetail[data.day].afternoon.length }}班</el-button
                >
              </div>
            </template>
          </div>
        </template>
      </el-calendar>
      <table class="native-table" v-if="curDay">
        <tr>
          <th>学年</th>
          <th>学期</th>
          <th>班级名称</th>
          <th>所属部门</th>
          <th>课程时间</th>
          <th>任课老师</th>
        </tr>
        <tr v-for="item in roomUseDetail[curDay][curTime]" :key="item.id">
          <td>{{ item.year }}</td>
          <td>{{ item.term }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.org_name }}</td>
          <td>{{ item.class_start_time | time }} 一 {{ item.class_end_time | time }}</td>
          <td>{{ item.teacher.length ? item.teacher.map(item => item.real_name).join('，') : '' }}</td>
        </tr>
      </table>
    </div>
  </el-dialog>
</template>
<script>
import { Calendar, Dialog } from 'element-ui';
import dayjs from 'dayjs';
import { base } from '@/api';
import utils from '@/utils/utils';

export default {
  name: 'RoomUse',
  props: {
    curRow: {
      type: Object,
      required: true
    }
  },
  components: {
    ElDialog: Dialog,
    ElCalendar: Calendar
  },
  watch: {
    curRow() {
      const date = dayjs();
      this.showRow(this.getStartAndEnd(date.subtract(date.date(), 'day')));
    }
  },
  data() {
    return {
      dialogVisibleDt: false,
      loading: false,
      roomUseDetail: {},
      curDay: '',
      curTime: '',
      caDate: ''
    };
  },
  filters: {
    time(value) {
      return value ? dayjs(value).format('HH:mm') : '';
    }
  },
  methods: {
    open() {
      this.caDate = new Date();
      this.dialogVisibleDt = true;
      this.$nextTick(() => {
        // 点击前一个月
        const prevBtn = document.querySelector(
          '.el-calendar__button-group .el-button-group>button:nth-child(1)'
        );
        prevBtn.addEventListener('click', () => {
          this.curDay = '';
        });
      });
      this.$nextTick(() => {
        // 点击后一个月
        const nextBtn = document.querySelector(
          '.el-calendar__button-group .el-button-group>button:last-child'
        );
        nextBtn.addEventListener('click', () => {
          this.curDay = '';
        });
      });
    },
    activeItem(curTime, curDay) {
      this.curTime = curTime;
      this.curDay = curDay;
    },
    reset() {
      this.curTime = '';
      this.curDay = '';
      this.caDate = '';
    },
    getStartAndEnd(value) {
      const date = dayjs(value);
      const day = date.day();
      const start = date.subtract((day + 6) % 7, 'day');
      const end = start.add(42, 'day');
      return {
        start_time: `${start.format('YYYY-MM-DD')} 00:00:00`,
        end_time: `${end.format('YYYY-MM-DD')} 00:00:00`
      };
    },
    setNewMonth(value) {
      const date = dayjs(value);
      if (date.date() === 1) this.showRow(this.getStartAndEnd(value));
      else this.showRow(this.getStartAndEnd(date.subtract(date.date(), 'day')));
    },
    async showRow({ start_time, end_time }) {
      this.dialogVisibleDt = true;
      this.loading = true;
      const res = await base.getRoomUseDetail({
        id: this.curRow.id,
        params: {
          start_time,
          end_time
        }
      });
      if (res && res.data) {
        const tmp = {};
        res.data.list.map(item => {
          const day = dayjs(item.class_start_time);
          const cur = tmp[day.format('YYYY-MM-DD')] || { morning: [], afternoon: [] };
          if (day.hour() <= 12) {
            cur.morning.push({ ...item });
          } else {
            cur.afternoon.push({ ...item });
          }
          tmp[day.format('YYYY-MM-DD')] = cur;
          return item;
        });
        this.roomUseDetail = tmp;
      }
      this.loading = false;
    },
    exportExcel() {
      base.exportClassRoomUse({
        params: {
          classroom_id: this.curRow.id
        }
      }).then(data => {
        if (data) utils.downloadData(data, '教室使用情况');
      });
    },
    clickDay(data) {
      if (!this.roomUseDetail[data.day]) {
        this.reset();
      }
    }
  }
};
</script>
<style lang="less">
.room-use-detail {
  .morning,
  .afternoon {
    padding: 6px 4px;
    margin: 0 0 4px 0;
    float: left;
  }
  .day{
    height:100%;
    overflow: hidden;
  }
}
</style>
